import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Input } from '@angular/core';
import { BaseComponent, UserService, BaseDataService, BaseCommonComponent, ModalService, TableRowColor, ConditionType, LoaderService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
//import { formGroupNameProvider } from '@angular/forms/src/directives/reactive_directives/form_group_name';
import { FormGroup, FormControl, Validators } from '@angular/forms';
//import { formControlBinding } from '@angular/forms/src/directives/ng_model';
import { NetoOtkupniFond } from './neto-otkupni-fond';
// import { NotificationsService } from 'angular2-notifications';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-neto-otkupni-fond',
  templateUrl: './neto-otkupni-fond.component.html'
})
export class NetoOtkupniFondComponent 
extends BaseCommonComponent
implements OnInit {
  Config={}
  mainItems=[]

  baseFormGroup:FormGroup=new FormGroup({
    DatumOd:new FormControl()
    , DatumDo:new FormControl()
    , ValutaID:new FormControl()
  })

  //get fc() { return this.baseFormGroup.controls; }
  submitted: boolean = false;
  ID: number;
  rowColors: TableRowColor[] = [
    //{ 
      //ColumnName: 'Razlika',
      //Condition: ConditionType.LessThan,
      //Value: 0,
      //Color: '#ffb6a6'
    //},
    //{
      //ColumnName: 'Razlika',
      //Condition: ConditionType.GreaterThan,
      //Value: 0,
      //Color: '#00ff00'
    //}
  ];
  
  constructor(

    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected baseDataService: BaseDataService,
    protected translateService: TranslateService,
    protected modalService: ModalService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected loaderService: LoaderService
  ) {

    super(activatedRoute, userService, baseDataService, translateService, modalService,toastrService, loaderService);
   }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("DatumOd", Validators.required, 'required', 'NETOOTKUPNIFOND.DATUMOD.VALIDATION.REQUIRED');
    this.addValidatorToFc("DatumDo", Validators.required, 'required', 'NETOOTKUPNIFOND.DATUMDO.VALIDATION.REQUIRED');
    this.addValidatorToFc("ValutaID", Validators.required, 'required', 'NETOOTKUPNIFOND.VALUTANAZIV.VALIDATION.REQUIRED');
  }

  OnModelDataLoaded(){
    super.OnModelDataLoaded();
    this.Config={
      EditIcon: {
        Visible: false
      },
      DeleteIcon: {
        Visible: false
      },
      DefaultSortKey: this.modelData.MainList.SortBy,
      DefaultSortReverse: this.modelData.MainList.SortReverse,
      ShowIndex: false,
      ShowDefaultListButtons: false,
      Height: '100w',
      ShowCheckBoxes: false,
      PrintIcon: {
        Visible: false
      }
      ,BreadCrumble: this.modelData.BreadcrumbLabel
    }
  
  }

  // loadData()
  // {
  //   this.baseDataService.Post<NetoOtkupniFond>(this.modelData.MainList.ModelName, this.modelData.MainList.GetName, this.baseFormGroup.value, this.modelData.MainList.ModelClass)
  //   .subscribe((data: NetoOtkupniFond[]) => {
  //     this.mainItems=data;
  //   })    
  // }
}
